module.exports = __webpack_public_path__ + "static/media/java.8039d73f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/java.jpg
// module id = 261
// module chunks = 0